import { TpvSettlement } from '@app/domain/models/tpv/settlement.model';
import { SettlementDto } from '@app/data/dtos/tpv/settlement.dto';

/** DTO de liquidación -> entidad de dominio. */
export function mapSettlement(dto: SettlementDto): TpvSettlement {
  return {
    merchantName: dto.merchant_name ?? '',
    date: dto.date ?? '',
    orderingTitular: dto.ordering_titular ?? '',
    orderingClabe: dto.ordering_clabe ?? '',
    beneficiaryTitular: dto.beneficiary_titular ?? '',
    beneficiaryClabe: dto.beneficiary_clabe ?? '',
    bank: dto.bank ?? '',
    amount: Number(dto.amount ?? 0),
    concept: dto.concept ?? '',
    reference: dto.reference ?? '',
    trackingKey: dto.tracking_key ?? '',
    operationType: dto.operation_type ?? '',
    captured: dto.captured ?? '',
  };
}
